export const prependProtocolToUrl = (inputUrl: string) => {
    const protolRegex = new RegExp(`^[a-z]{1,100}://`);
    return protolRegex.test(inputUrl) ? inputUrl : `http://${inputUrl}`;
};
